import MainImg from "../images/chooseUs/velozinterior.webp";
import Box1 from "../images/chooseUs/icon1.png";
import Box2 from "../images/chooseUs/icon2.png";
import Box3 from "../images/chooseUs/icon3.png";
import { IconChevronRight } from "@tabler/icons-react";

function ChooseUs() {
  return (
    <>
      <section className="choose-section">
        <div className="container">
          <div className="choose-container">
          <div className="chooseus__overlay"></div>
            <div className="text-container">
              <div className="text-container__left">
                <h4>Why Choose Us</h4>
                <h2>Best valued deals you will ever find</h2>
                <p>
                 Looking for unbeatable value and top-notch service? 
                 Look no further! Our car rental service offers the 
                 best value for your money with a fleet of well-maintained, 
                 fuel-efficient vehicles that cater to all your needs. 
                 Enjoy hassle-free booking, flexible rental options, 
                 and exceptional customer support every step of the way. 
                 Whether you're planning a weekend getaway, a business trip, 
                 or just need a reliable ride, we've got you covered. 
                 Choose us for an affordable, convenient, and enjoyable rental experience. 
                 Drive with confidence and peace of mind—only with the best value car rental service in town!
                </p>
                <a href="/pricing">
                  Find Details &nbsp;
                  <IconChevronRight />
                </a>
              </div>
              <div className="text-container__right">
                <div className="text-container__right__box">
                  <img src={Box1} alt="car-img" />                  
                  <div className="text-container__right__box__text">
                    <h4>Reliable And Spacious</h4>
                    <p>
                      Take your driving experience to the next level with our
                      reliable and spacious vehicles for your adventures.
                    </p>
                  </div>
                </div>
                <div className="text-container__right__box">
                  {" "}
                  <img src={Box2} alt="coin-img" />
                  <div className="text-container__right__box__text">
                    <h4>All Inclusive Pricing</h4>
                    <p>
                      Get everything you need in one convenient, transparent
                      price with our all-inclusive pricing policy.
                    </p>
                  </div>
                </div>
                <div className="text-container__right__box">
                  {" "}
                  <img src={Box3} alt="coin-img" />
                  <div className="text-container__right__box__text">
                    <h4>No Hidden Charges</h4>
                    <p>
                      Enjoy peace of mind with our no hidden charges policy. We
                      believe in transparent and honest pricing.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ChooseUs;
